<template>
  <div>
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Solte os arquivos para anexar</h3>
    </div>
    <div class="upload">
      <file-upload
        ref="upload"
        v-model="files"
        :post-action="postAction"
        :custom-action="handleUpload"
        :accept="accept"
        :multiple="false"
        :directory="false"
        :size="size || 0"
        :headers="headers"
        :data="data"
        :drop="true"
        :drop-directory="false"
        :add-index="false"
        @input-filter="inputFilter"
        @input-file="inputFile"
      >
      </file-upload>
      <template v-if="file">
        <img
          v-if="file.thumb"
          :src="file.thumb"
          width="40"
          height="auto"
          alt="Preview da imagem"
        />
        <span class="filename" :class="{ 'text-danger': file.error }">
          {{ file.name }} {{ file.size | formatSize }}<br />
          <small v-if="file.error">{{ getErrorDescription(file.error) }}</small>
        </span>
        <span v-if="file.active || file.progress !== '0.00'" class="progress">
          <span
            :class="{
              'progress-bar': true,
              'progress-bar-striped': true,
              'bg-danger': file.error,
              'progress-bar-animated': file.active,
            }"
            role="progressbar"
            :style="{ width: file.progress + '%' }"
            >{{ file.progress }}%</span
          >
        </span>
        <div>
          <b-button :disabled="disabled" variant="link" @click="selectFile"
            ><i class="fas fa-file-upload" aria-hidden="true"></i>
            Substituir
          </b-button>
        </div>
      </template>
      <template v-else>
        <b-button @click="selectFile">
          <i class="fa fa-file-upload" aria-hidden="true"></i>
          Selecione o arquivo
        </b-button>
      </template>
    </div>
  </div>
</template>
<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";
import FileUpload from "vue-upload-component";

export default {
  name: "SingleFileUpload",
  components: {
    FileUpload,
  },
  props: {
    postAction: {
      type: String,
      required: true,
    },
    headers: {
      type: Object,
      default: () => {
        return {};
      },
    },
    data: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  data() {
    return {
      files: [],
      accept: "image/*,audio/*,video/*,text/plain,application/pdf",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      thread: 3,
      name: "file",
      editFile: {
        show: false,
        name: "",
        scaleX: 1,
        scaleY: 1,
      },
      uploading: false,
      filesToUpload: 0,
    };
  },
  computed: {
    hasInvalidFiles() {
      for (const file of this.files) {
        if (file.error) {
          return true;
        }
      }
      return false;
    },
    file() {
      return this.files.length > 0 ? this.files[0] : null;
    },
  },
  watch: {
    "editFile.show"(newValue, oldValue) {
      //  error
      if (!newValue && oldValue) {
        this.$refs.upload.update(this.editFile.id, {
          error: this.editFile.error || "",
        });
      }
      if (newValue) {
        this.$nextTick(function () {
          if (!this.$refs.editImage) {
            return;
          }
          let cropper = new Cropper(this.$refs.editImage, {
            autoCrop: false,
          });
          this.editFile = {
            scaleX: 1,
            scaleY: 1,
            ...this.editFile,
            cropper,
          };
        });
      }
    },
  },
  methods: {
    getErrorDescription(error) {
      switch (error) {
        case "size":
          return "Tamanho deve ser maior que 1 KB e menor que 10 MB";
        case "extension":
          return "Extensão inválida";
        case "timeout":
          return "Tempo excedido";
        case "abort":
          return "Abortado";
        case "network":
          return "Erro de rede";
        case "server":
          return "Erro no servidor";
        case "denied":
          return "Negado";
        case "edit":
          return "Editando...";
        default:
          return `Erro desconhecido ${error}`;
      }
    },

    async handleUpload(file, component) {
      await component.uploadHtml5(file);
      this.filesToUpload--;
      if (this.filesToUpload === 0) {
        this.uploading = false;
        this.$emit("upload-complete");
      }
    },
    selectedFile() {
      return this.file;
    },

    start() {
      if (this.uploading) return;
      this.uploading = true;
      let count = 0;
      for (const file of this.files) {
        if (!file.error) {
          count++;
        }
      }
      this.filesToUpload = count;
      this.$refs.upload.active = true;
    },
    stop() {
      this.uploading = false;
      this.$refs.upload.active = false;
    },
    selectFile() {
      document.getElementById("file").click();
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
        // size verification
        if (
          newFile.size >= 0 &&
          this.minSize > 0 &&
          newFile.size < this.minSize
        ) {
          newFile.error = "size";
        }

        if (newFile.size >= 0 && newFile.size > this.size) {
          newFile.error = "size";
        }
      }
    },

    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update
        if (newFile.active && !oldFile.active) {
          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.upload.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
        }
        if (newFile.error && !oldFile.error) {
          // error
        }
        if (newFile.success && !oldFile.success) {
          // success
        }
      }
      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response.id) {
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/upload/delete?id=' + oldFile.response.id,
          // })
        }
      }
      this.$emit("file-changed");
    },
    alert(message) {
      alert(message);
    },
    onEditFileShow(file) {
      this.editFile = { ...file, show: true };
      this.$refs.upload.update(file, { error: "edit" });
    },
    onEditorFile() {
      if (!this.$refs.upload.features.html5) {
        this.alert("Seu navegador não suporta essa funcionalidade");
        this.editFile.show = false;
        return;
      }
      let data = {
        name: this.editFile.name,
      };
      if (this.editFile.cropper) {
        let binStr = atob(
          this.editFile.cropper
            .getCroppedCanvas()
            .toDataURL(this.editFile.type)
            .split(",")[1]
        );
        let arr = new Uint8Array(binStr.length);
        for (let i = 0; i < binStr.length; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        data.file = new File([arr], data.name, { type: this.editFile.type });
        data.size = data.file.size;
      }
      this.$refs.upload.update(this.editFile.id, data);
      this.editFile.error = "";
      this.editFile.show = false;
    },
  },
};
</script>
<style scoped>
.edit-image img {
  max-width: 100%;
}

.edit-image-tool {
  margin-top: 0.6rem;
}
</style>
